import { render } from "./BigImageDialog.vue?vue&type=template&id=024e41c7"
import script from "./BigImageDialog.vue?vue&type=script&lang=js"
export * from "./BigImageDialog.vue?vue&type=script&lang=js"

import "./BigImageDialog.vue?vue&type=style&index=0&id=024e41c7&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__